export default [
  {
    name: "kurator-main",
    component: () =>
      import("@/modules/Kurator/pages/KuratorDashboard/KuratorDashboard.vue"),
    path: "/kurator-dashboard",
    meta: {
      layout: "main",
      auth: true,
      role: ["kurator"],
    },
  },
  {
    name: "kurator-groups-main",
    component: () =>
      import("../../modules/Admin/pages/GroupList/GroupList.vue"),
    path: "/kurator-groups",
    meta: {
      layout: "main",
      auth: true,
      role: ["kurator"],
    },
  },
  {
    name: "kurator-stats",
    component: () =>
      import("@/modules/Kurator/pages/KuratorStats/KuratorStats.vue"),
    path: "/kurator-stats",
    meta: {
      layout: "main",
      auth: true,
      role: ["kurator"],
    },
  },
];
